/**
 * Create a machine-readable device attribute key name
 *
 * @param {string} name Device attribute name
 * @returns {string} Returns the machine-readable name
 */
export default function (name) {
	return 'attribute_' + name.toLowerCase()
		.replace(/[\s-]+/g, '_') // Replace whitespace & dash with underscore
		.replace(/[^a-zA-Z0-9_]+/g, ''); // Remove non-alphanumeric characters
}
